import React from 'react';
import { Button } from '../ui/Button';
export const Hero = () => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="hero" className="min-h-screen w-full flex flex-col justify-center relative overflow-hidden bg-purple-50" data-id="element-331">
      {/* Background pattern elements - Using CSS gradients instead of large background images */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-purple-100 to-purple-50 rounded-full opacity-40 -mr-48 -mt-48" data-id="element-332"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tl from-purple-100 to-purple-50 rounded-full opacity-30 -ml-40 -mb-40" data-id="element-333"></div>
      <div className="container mx-auto px-4 md:px-6 py-24 pt-32 relative z-10" data-id="element-334">
        <div className="max-w-4xl mx-auto" data-id="element-335">
          <p className="text-text-secondary text-lg mb-4" data-id="element-336">
            Meet a senior ai strategist on your first call. No SDRs. Start
            within 48 hours.
          </p>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-black mb-6 leading-tight" data-id="element-337">
            Your Personal{' '}
            <span className="text-primary" data-id="element-338">AI Product Manager.</span>
            <br data-id="element-339" />
            Supercharged by <span className="text-primary" data-id="element-340">AI.</span>
          </h1>
          <div className="flex flex-col sm:flex-row gap-4 mt-10" data-id="element-341">
            <Button variant="primary" onClick={openCalendly} className="text-lg" data-id="element-342">
              Speak with a Senior PM
            </Button>
            <Button variant="secondary" onClick={() => scrollTo('pricing')} className="text-lg" data-id="element-343">
              See pricing
            </Button>
            <a href="#no-interview-band" className="text-sm text-primary hover:underline mt-4 sm:mt-3 sm:ml-4 flex items-center" onClick={e => {
            e.preventDefault();
            scrollTo('no-interview-band');
          }} data-id="element-344">
              How we start
            </a>
          </div>
        </div>
      </div>
    </section>;
};